import { Box, Menu } from "@mui/material";
import { CrossButton } from "../../../assets/common-svg/CommonSvg";
import { useFormik } from "formik";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import { getValueByPath } from "../../../utils/utils"
import { FormCommentList } from "../../../components/form-template/FormCommentList";
import { useDispatch, useSelector } from "react-redux";
import {
  queryChat,
  raisedQuery,
  rejectQuery,
  resolvedQuery,
  selectQueryLoading,
} from "../../../bmr/slices/queryInBound";
import {
  updateInBoundForm,
} from "../../../bmr/slices/inbound";
import moment from "moment";
import { notify } from "../../../bmr/utils/methods/notification";
import { selectCurrentCycle } from "../../../bmr/slices/common"

const validationSchema = Yup.object().shape({
  comment: Yup.string()
    .required("Comment is required")
    .max(200, "Enter less than 200 characters"),
});

const FormFirstPartFields = [
  "hospital_name",
  "hospital_patient_id",
  "immunoact_patient_id",
  "full_name",
  "initials",
  "dob",
  "disease_indication",
];

const FormSecondPartFields = [
  "date_of_receipt",
  "temperature_at_receipt",
  "time_of_receipt",
  "quantity_received",
  "leakage",
  "leakage_comment",
  "seal_broken_comment",
  "transport_box_damaged_comment", 
  "temperature_excursion_comment",
  "seal_broken",
  "transport_box_damaged",
  "temperature_excursion",
  "excursion_time",
  "excursion_temp",
  "excursion_duration",
  "receipt_photo",
  "remarks",
];

const InBoundComment = ({
  handleMenuClose,
  anchorEl,
  open,
  queryData,
  selectedField,
  checkInBoundForm,
  getPrimaryDiagnosis,
  formValues,
  handleManualFormikValidaction,
}) => {
  const dispatch = useDispatch();
  const LoginData = useSelector((state) => state.loginData);
  const role_id = LoginData?.role_id;
  const role_slug = LoginData?.role_slug;
  const isEditor = role_id === 5;
  const isLoading = useSelector(selectQueryLoading);
   const currentCycle = useSelector(selectCurrentCycle)
  const initialValues = {
    comment: "",
  };

  const handleSubmit = async (values) => {
   let finalVal = selectedField.field_value;
  if(selectedField.field_name == 'date_of_receipt' || selectedField.field_name == 'collection_date' || selectedField.field_name == 'date_of_dispatch'){
   finalVal =  moment(selectedField.field_value,"DD/MM/YYYY").format("DD/MM/YYYY")
  }
  if(selectedField.field_name == 'time_of_receipt' || selectedField.field_name == 'time_of_dispatch' || selectedField.field_name == 'stop_time' || selectedField.field_name == 'start_time'){
      finalVal = moment(selectedField?.field_value, "HH:mm:ss").format("HH:mm")
  }
    const data = {
      inbound_id: selectedField?.inbound_id,
      patient_id: selectedField.patient_id,
      field_id: selectedField.field_id,
      data: {
        is_file: selectedField?.is_file,
        field_label: selectedField.field_label ?? selectedField?.field_name,
        field_name: selectedField.field_name,
        field_value: selectedField?.is_file
          ? selectedField.field_value
          : `${finalVal}`,
        query: values.comment,
        type: 2,
        resolve_by: selectedField?.isResolve,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id
      },
    };
    if (selectedField?.field_id && selectedField?.resolve == 0) {
      await dispatch(
        queryChat({
          id: selectedField?.field_id,
          data: { query: values?.comment, resolve_by: selectedField?.isResolve,
            feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id
          },
        })
      );
    } else {
      await dispatch(raisedQuery(data));
    }
    getPrimaryDiagnosis();
    handleMenuClose();
  };

  const updateForm = async (values) => {
    let deepCopiedValues = structuredClone(values);
    const formData = new FormData();
    (!isEditor ? FormFirstPartFields : FormSecondPartFields)?.forEach(
      (key) => delete deepCopiedValues[key]
    );

    // Transforming form values for submission
    const transformedFormValues = isEditor
      ? {
          ...deepCopiedValues,
          sample_types: deepCopiedValues.sample_types,
          lsm_volumes: deepCopiedValues.lsm_volumes,       
          collection_date: moment(
            deepCopiedValues.collection_date,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD"),
          date_of_dispatch: moment(
            deepCopiedValues.date_of_dispatch,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD"),
          sample_photo: deepCopiedValues?.sample_photo?.id
            ? deepCopiedValues?.sample_photo?.id
            : null,
          upload_report_log_file: deepCopiedValues?.upload_report_log_file?.id
            ? deepCopiedValues?.upload_report_log_file?.id
            : null,
        }
      : {
          ...deepCopiedValues,
          date_of_receipt: deepCopiedValues.date_of_receipt
            ? moment(deepCopiedValues.date_of_receipt, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
              )
            : "",
          receipt_photo: deepCopiedValues?.receipt_photo?.id
            ? deepCopiedValues?.receipt_photo?.id
            : null,
        };

    Object.entries(transformedFormValues).forEach(([key, value]) => {
      if (
        (key === "receipt_photo" && Array.isArray(value)) ||
        (key === "media_id" && Array.isArray(value))
      ) {
        value = value?.[0];
      }
       if(key == 'lsm_volumes' || key == 'sample_types'){
      formData.set(key, JSON.stringify(value));
       }else{
       if (value !== undefined && value !== null && value != '') {
        formData.append(key, value);
      }
    }
    });
     await dispatch(
      updateInBoundForm({ id: selectedField.inbound_id, data: formData })
    );
  };

  const resolvedOurQuery = async () => {
            await formik.validateForm();
        if (!formik?.values?.comment?.trim() || !formik?.isValid) {
                return notify.error('Please add the comment')
            }
    let check = await handleManualFormikValidaction();
    if (check == 1) {
      try {
        const data = formValues;
        let oldValue = getValueByPath(checkInBoundForm, selectedField?.field_name);
        let newValue = getValueByPath(data, selectedField?.field_name);
        if(selectedField.field_name == 'date_of_receipt' ||  selectedField.field_name == 'collection_date' || selectedField.field_name == 'date_of_dispatch'){
        oldValue =  moment(oldValue).format("DD/MM/YYYY");
        newValue =  moment(newValue,"DD/MM/YYYY").format("DD/MM/YYYY")
        }
        if(selectedField.field_name == 'time_of_receipt' || selectedField.field_name == 'time_of_dispatch' || selectedField.field_name == 'stop_time' || selectedField.field_name == 'start_time'){
        oldValue = moment(oldValue,"HH:mm:ss").format("HH:mm");
        newValue = moment(newValue, "HH:mm:ss").format("HH:mm")
        }
        if (oldValue == newValue) {
         notify.error(
              "Please change the field's value first, then resolve query."
            )
        } else {
          let finalValue = selectedField?.field_value
          if(selectedField.field_name == "patient_body_weight" || selectedField.field_name == "lvef_percentage" || selectedField.field_name == "b_all_blast_percentage"){
          finalValue = newValue?.toFixed(2)
          }
          updateForm(data);
          await dispatch(
            resolvedQuery({
              id: selectedField.field_id,
              data: {
                new_value: finalValue,
                is_file: selectedField?.is_file,
              },
            })
          );
          getPrimaryDiagnosis();
        }
      } catch (error) {
        console.error("Error in resolvedOurQuery:", error);
      }
    }
    handleMenuClose();
  };

  const rejectOurQuery = async () => {
    await dispatch(rejectQuery(selectedField.field_id));
    getPrimaryDiagnosis();
    handleMenuClose();
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const formOptions = {
    type: "textarea",
    disabled: false,
    required: true,
    name: "comment",
    placeholder: "Enter Comment",
  };

  return (
    <div>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <Box className="p-2">
          <div className="flex flex-row-reverse border-b border-gray-300 pb-2">
            <p className="flex gap-1 mr-3">
              <span
                className="cursor-pointer"
                onClick={() => handleMenuClose()}
              >
                <CrossButton />
              </span>
            </p>
          </div>
          <div className="p-3">
            {queryData?.length != 0 ? (
              <FormCommentList
                loading={isLoading}
                MenuData={queryData.map((op) => {
                  return {
                    name: `${op.raised_by[0]}${op.raised_by[1]}`,
                    title: op.raised_by,
                    describe: op.query,
                    date: op.created_at,
                    ...op,
                  };
                })}
              />
            ) : (
              ''
            )}
          </div>
          <form className="" onSubmit={formik.handleSubmit}>
            <FormikControl formik={formik} {...formOptions} className="mt-2" />
            <div className="flex gap-2 mt-2">
              {(role_id !== 5 ||
                (role_id === 5 &&
                  selectedField?.id &&
                  selectedField?.resolve == 0)) && (
                <LoadingButton
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={isLoading}
                  className="disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Submit
                </LoadingButton>
              )}
              {selectedField?.isResolve?.includes(role_slug) && <LoadingButton
                type="button"
                disabled={isLoading || selectedField?.resolve != 0}
                onClick={() => resolvedOurQuery()}
                className="!bg-[#00B278] disabled:!bg-[#A0D9C7] disabled:cursor-not-allowed"
                color="success"
                variant="contained"
                fullWidth
              >
                Resolved
              </LoadingButton>}

              <LoadingButton
                type="button"
                disabled={isLoading || selectedField?.resolve !== 0}
                onClick={() => rejectOurQuery()}
                className={`!border-[#FF2023] !text-[#FF2023] 
                                        ${
                                          isLoading ||
                                          selectedField?.resolve !== 0
                                            ? "!border-[#FCA5A5] !text-[#FCA5A5] cursor-not-allowed opacity-50"
                                            : ""
                                        }`}
                variant="outlined"
                fullWidth
              >
                Reject
              </LoadingButton>
            </div>
          </form>
        </Box>
      </Menu>
    </div>
  );
};

export default InBoundComment;
